import request from '@/utils/request';
export function fetchList(data) {
  return request({
    url: '/whg-park/api/placeArea/list',
    method: 'post',
    data: data
  });
}
export function fetchDetail(data) {
  return request({
    url: '/whg-park/api/placeArea/get',
    method: 'post',
    data: data
  });
}
export function fetchDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/whg-park/api/placeArea/delete',
    method: 'post',
    data: data
  });
}
export function fetchCreate(data) {
  return request({
    url: '/whg-park/api/placeArea/insert',
    method: 'post',
    data: data
  });
}
export function fetchUpdate(data) {
  return request({
    url: '/whg-park/api/placeArea/update',
    method: 'post',
    data: data
  });
}
export function lightCloseAll(data) {
  return request({
    url: '/whg-park/api/placeArea/lightCloseAll',
    method: 'post',
    data: data
  });
}
export function lightOpenAll(data) {
  return request({
    url: '/whg-park/api/placeArea/lightOpenAll',
    method: 'post',
    data: data
  });
}
export function orderLightOpenAll() {
  return request({
    url: '/whg-park/api/placeArea/orderLightOpenAll',
    method: 'post'
  });
}